import { render, staticRenderFns } from "./TptPatientFilter.vue?vue&type=template&id=0da419b6&scoped=true"
import script from "./TptPatientFilter.vue?vue&type=script&lang=js"
export * from "./TptPatientFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da419b6",
  null
  
)

export default component.exports